{
  "runs": {
    "title": "Runlogboek",
    "description": "Elke agentrun met prompt, redenering, toolaanroepen, tokens en kosten.",
    "detailTitle": "Run",
    "backToList": "Alle runs",
    "openPage": "Als pagina openen",
    "refresh": "Vernieuwen",
    "autoRefresh": "Live bijgewerkt",
    "search": "Zoeken in prompts en uitvoer…",
    "unknownAgent": "Onbekende agent",
    "cancel": "Run annuleren",
    "cancelRequested": "Run wordt geannuleerd…",
    "failedTitle": "De run is mislukt",
    "noOutput": "Geen uitvoer.",
    "noPrompt": "Geen prompt.",
    "tokensSplit": "{{input}} in · {{output}} uit",
    "cacheSplit": "cache {{read}} gelezen · {{write}} geschreven",
    "stepsAndTools": "{{steps}} stappen · {{tools}} toolaanroepen",
    "tokenCount_one": "tokens: {{count}}",
    "tokenCount_other": "tokens: {{count}}",
    "columns": {
      "status": "Toestand",
      "run": "Agent en prompt",
      "agent": "AI-agent",
      "source": "Bron",
      "model": "Taalmodel",
      "tokens": "Tokengebruik",
      "cost": "Kosten",
      "tools": "Toolaanroepen",
      "duration": "Duur",
      "started": "Gestart"
    },
    "filters": {
      "allAgents": "Alle agents",
      "allSources": "Alle bronnen",
      "allStatuses": "Elke toestand",
      "from": "Vanaf datum",
      "to": "Tot datum",
      "clear": "Filters wissen"
    },
    "empty": {
      "title": "Nog geen runs",
      "description": "Runs verschijnen hier zodra een agent antwoordt in de chat, een automatisering, de API of de testomgeving."
    },
    "emptyFiltered": {
      "title": "Geen runs voor deze filters",
      "description": "Kies een andere periode of wis de filters."
    },
    "status": {
      "running": "Bezig",
      "connecting": "Verbinden",
      "completed": "Voltooid",
      "failed": "Mislukt",
      "cancelled": "Geannuleerd",
      "waiting": "Wachtend",
      "paused": "Gepauzeerd"
    },
    "source": {
      "chat": "Chatgesprek",
      "playground": "Testomgeving",
      "api": "API",
      "endpoint": "Chat-endpoint",
      "automation": "Automatisering",
      "automation_hook": "Automatiseringshook",
      "schedule": "Planning",
      "workplace": "Werkplek",
      "task": "Taak",
      "eval": "Evaluatie",
      "connector": "Koppeling"
    },
    "live": {
      "title": "Bezig",
      "working": "Aan het werk…",
      "reconnecting": "Opnieuw verbinden met de livestream…"
    },
    "fields": {
      "model": "Taalmodel",
      "tokens": "Tokengebruik",
      "cost": "Kosten",
      "duration": "Duur",
      "prompt": "Opdracht",
      "reasoning": "Redenering",
      "toolCalls_one": "{{count}} toolaanroep",
      "toolCalls_other": "{{count}} toolaanroepen",
      "output": "Uitvoer",
      "details": "Gegevens",
      "agent": "AI-agent",
      "source": "Bron",
      "user": "Gebruiker",
      "started": "Gestart",
      "completed": "Afgerond",
      "runId": "Run-ID",
      "context": "Gesprek",
      "metadata": "metagegevens"
    },
    "tools": {
      "arguments": "argumenten",
      "result": "resultaat",
      "error": "fout",
      "running": "Bezig…",
      "noResult": "Geen resultaat."
    },
    "cancelledTitle": "De run is geannuleerd",
    "cancelledDescription": "Hij is gestopt voordat hij klaar was; wat al gemaakt was, blijft bewaard."
  },
  "monitor": {
    "title": "Live-overzicht",
    "description": "Alles wat nu draait: agent-runs, chatbeurten en teamruimtes. Stop losse onderdelen of trek aan de noodrem.",
    "updated": "Bijgewerkt",
    "since": "Sinds",
    "stale": "Geen hartslag",
    "staleHint": "De node die deze run uitvoert heeft zich al een tijd niet gemeld en is waarschijnlijk gestopt. Annuleren markeert de run als geannuleerd.",
    "untitledChat": "Naamloze chat",
    "roomPaused": "Gepauzeerd",
    "thinking": "Denkt na",
    "activeRuns_one": "{{count}} actief",
    "activeRuns_other": "{{count}} actief",
    "scope": {
      "tenant": "Deze organisatie",
      "platform": "Alle organisaties"
    },
    "connection": {
      "live": "Verbonden",
      "connecting": "Verbinden…",
      "reconnecting": "Opnieuw verbinden…",
      "polling": "Periodiek verversen"
    },
    "health": {
      "dbOk": "Database in orde",
      "dbDown": "Database onbereikbaar",
      "nodeRuns_one": "{{count}} run op deze node",
      "nodeRuns_other": "{{count}} runs op deze node"
    },
    "kpi": {
      "runs": "Lopende runs",
      "sessions": "Actieve chats",
      "rooms": "Bezette ruimtes",
      "stale": "Vastgelopen runs",
      "staleHint": "Runs waarvan de node niet meer reageert"
    },
    "sections": {
      "runs": "Lopende runs",
      "runsHint": "Klik op een run om de uitvoer live te volgen.",
      "sessions": "Chatsessies",
      "rooms": "Teamruimtes"
    },
    "columns": {
      "organization": "Organisatie",
      "chatSession": "Gesprek",
      "steps": "Stappen",
      "running": "Loopt al"
    },
    "actions": {
      "watch": "Live volgen",
      "openRun": "Openen in runlog",
      "cancelRun": "Run annuleren",
      "cancelSession": "Chat stoppen",
      "stopRoom": "Ruimte stoppen"
    },
    "confirm": {
      "runTitle": "Deze run annuleren?",
      "runDescription": "{{agent}} stopt bij het volgende controlepunt. Wat al is gemaakt blijft bewaard.",
      "sessionTitle": "Deze chat stoppen?",
      "sessionDescription": "Alle lopende beurten van “{{title}}” worden geannuleerd. Het gesprek zelf blijft bewaard.",
      "roomTitle": "Deze ruimte stoppen?",
      "roomDescription": "Al het lopende werk in “{{title}}” stopt en denkende workers worden vrijgegeven. Berichten blijven bewaard."
    },
    "empty": {
      "runsTitle": "Er draait niets",
      "runsDescription": "Runs verschijnen hier zodra een agent begint en verdwijnen als ze klaar zijn.",
      "sessions": "Er is nu geen chat die een antwoord genereert.",
      "rooms": "Er is nu geen teamruimte aan het werk."
    },
    "toast": {
      "runCancelled": "De run wordt geannuleerd…",
      "notRunning": "Die run was al klaar.",
      "sessionCancelled_one": "{{count}} lopende beurt wordt geannuleerd…",
      "sessionCancelled_other": "{{count}} lopende beurten worden geannuleerd…",
      "roomStopped": "Ruimte gestopt"
    },
    "killAll": {
      "button": "Alles stoppen",
      "buttonCount_one": "Alles stoppen ({{count}})",
      "buttonCount_other": "Alles stoppen ({{count}})",
      "title": "Alles in deze organisatie stoppen?",
      "titlePlatform": "Alles op het platform stoppen?",
      "description": "Annuleert alle {{runs}} lopende runs en stopt {{rooms}} bezette ruimtes in deze organisatie. Alleen gebruiken in noodgevallen.",
      "descriptionPlatform": "Activeert de noodstop voor het hele cluster: elke lopende run van elke organisatie wordt geannuleerd ({{runs}} nu) en {{rooms}} bezette ruimtes worden gestopt.",
      "confirmWord": "STOPPEN",
      "action": "Alles stoppen",
      "done": "Noodstop geactiveerd: {{runs}} runs geannuleerd, {{rooms}} ruimtes gestopt."
    },
    "controller": {
      "title": "Landschapsregisseur",
      "open": "Regisseur",
      "ready": "Gereed",
      "notConfigured": "Geen monitormodel ingesteld",
      "setupHint": "Kies een monitormodel in de organisatie-instellingen om vragen te stellen over live activiteit en de regisseur runs voor je te laten annuleren.",
      "openSettings": "Organisatie-instellingen openen",
      "intro": "Vraag wat er draait, waarom iets vastzit, of laat de regisseur runs, chats of ruimtes voor je stoppen.",
      "suggestions": {
        "whatsRunning": "Wat draait er nu?",
        "stale": "Zijn er vastgelopen runs?",
        "summary": "Vat de huidige belasting samen"
      },
      "placeholder": "Vraag het de regisseur…",
      "send": "Versturen",
      "stop": "Stoppen",
      "stopped": "Gestopt",
      "thinking": "Denkt na…",
      "empty": "Geen antwoord.",
      "newConversation": "Nieuw gesprek",
      "hint": "Enter om te versturen, Shift+Enter voor een nieuwe regel. De regisseur kan runs binnen jouw bereik annuleren."
    }
  },
  "costs": {
    "title": "Kosten & gebruik",
    "description": "Uitgaven, tokens en aantallen runs uit geregistreerde agent-runs, per agent, model, gebruiker en bron.",
    "refresh": "Verversen",
    "views": {
      "tenant": "Deze organisatie",
      "platform": "Heel het platform"
    },
    "periods": {
      "today": "Vandaag",
      "24h": "Afgelopen 24 uur",
      "7d": "Afgelopen 7 dagen",
      "30d": "Afgelopen 30 dagen",
      "90d": "Afgelopen 90 dagen",
      "this_month": "Deze maand",
      "last_month": "Vorige maand",
      "custom": "Aangepaste periode"
    },
    "windows": {
      "1h": "Afgelopen uur",
      "6h": "Afgelopen 6 uur",
      "24h": "Afgelopen 24 uur",
      "today": "Vandaag",
      "3d": "Afgelopen 3 dagen",
      "7d": "Afgelopen 7 dagen",
      "14d": "Afgelopen 14 dagen",
      "30d": "Afgelopen 30 dagen",
      "90d": "Afgelopen 90 dagen",
      "365d": "Afgelopen 365 dagen"
    },
    "buckets": {
      "minute": "Per minuut",
      "hour": "Per uur",
      "day": "Per dag",
      "week": "Per week",
      "month": "Per maand"
    },
    "filters": {
      "period": "Periode",
      "from": "Vanaf datum",
      "to": "Tot datum",
      "allAgents": "Alle agents",
      "allModels": "Alle modellen",
      "allSources": "Alle bronnen",
      "user": "Gebruiker: {{name}}",
      "removeUser": "Gebruikersfilter verwijderen",
      "clear": "Filters wissen",
      "pickRange": "Kies een periode",
      "pickRangeHint": "Kies een begin- en einddatum (begin op of vóór einde) om de kosten van een aangepaste periode te zien."
    },
    "metrics": {
      "cost": "Kosten",
      "tokens": "Tokenverbruik",
      "runs": "Aantal runs",
      "inputTokens": "Invoertokens",
      "outputTokens": "Uitvoertokens",
      "okRuns": "Geslaagd of lopend",
      "failedRuns": "Mislukt"
    },
    "chart": {
      "title": {
        "cost": "Uitgaven door de tijd",
        "tokens": "Tokens door de tijd",
        "runs": "Runs door de tijd"
      },
      "description": "{{bucket}} opgeteld, in {{timezone}}.",
      "metric": "Maatstaf",
      "bucket": "Periode",
      "showTable": "Als tabel tonen",
      "zoomInto": "Inzoomen op {{bucket}}"
    },
    "kpi": {
      "cost": "Uitgaven",
      "avgPerRun": "gemiddeld {{value}} per run",
      "runs": "Aantal runs",
      "failed": "{{count}} mislukt · {{rate}} foutpercentage",
      "tokens": "Tokenverbruik",
      "latency": "Mediane duur",
      "latencyHint": "p90 {{p90}} · p99 {{p99}}",
      "toolCalls": "Toolaanroepen",
      "toolErrors_one": "{{count}} fout",
      "toolErrors_other": "{{count}} fouten",
      "agents": "Gebruikte agents",
      "users_one": "door {{count}} gebruiker",
      "users_other": "door {{count}} gebruikers"
    },
    "dimensions": {
      "agent": "Per agent",
      "model": "Per model",
      "user": "Per gebruiker",
      "source": "Per bron"
    },
    "columns": {
      "runs": "Aantal runs",
      "errorRate": "Foutpercentage",
      "tokens": "Tokenverbruik",
      "p50": "Mediane duur",
      "avgCost": "Per run",
      "cost": "Kosten",
      "share": "Aandeel",
      "name": "Naam"
    },
    "breakdown": {
      "title": "Uitsplitsing",
      "description": "Klik op een rij om de hele pagina daarop te filteren.",
      "dimension": "Groeperen op"
    },
    "empty": {
      "title": "Geen runs in deze periode",
      "description": "Kies een langere periode of wis de filters."
    },
    "tools": {
      "title": "Toolgebruik",
      "description": "Toolaanroepen van de runs in deze selectie.",
      "tool": "Toolnaam",
      "calls": "Aanroepen",
      "runs": "In runs",
      "errors": "Fouten",
      "avg": "Gem. duur",
      "p90": "p90",
      "search": "Tools zoeken…",
      "emptyTitle": "Geen toolaanroepen",
      "emptyDescription": "Geen van de runs in deze periode heeft een tool aangeroepen."
    },
    "budgets": {
      "title": "Budgetten",
      "description": "Huidige uitgaven ten opzichte van elk actief budgetbeleid.",
      "manage": "Budgetten beheren",
      "none": "Er is geen budgetbeleid actief."
    },
    "platform": {
      "window": "Tijdvenster",
      "liveChats": "Actieve chats",
      "liveChatsHint": "Bijgewerkt in de laatste {{minutes}} min",
      "liveRooms": "Live ruimtes",
      "liveRoomsHint": "Agents die nu aan het werk zijn",
      "toolCallsHint_one": "{{count}} toolaanroep",
      "toolCallsHint_other": "{{count}} toolaanroepen",
      "chatTurns": "Chatbeurten",
      "chatFailureRate": "{{rate}} mislukt ({{count}})",
      "avgDuration": "Gem. runduur",
      "avgDurationHint": "Alleen geslaagde runs",
      "signIns": "Ingelogde gebruikers",
      "sessionsTouched": "Chats: {{chats}} · Ruimtes: {{rooms}}",
      "chart": {
        "tokens": "Tokens door de tijd",
        "runs": "Runs door de tijd",
        "chat": "Chatbeurten door de tijd",
        "tools": "Toolaanroepen door de tijd"
      },
      "metrics": {
        "tokens": "Tokenverbruik",
        "runs": "Aantal runs",
        "chat": "Chatbeurten",
        "tools": "Toolaanroepen"
      },
      "chatOk": "Chatbeurten",
      "chatFailed": "Mislukte chatbeurten",
      "toolCalls": "Toolaanroepen",
      "drillHint": "Klik op een kolom, of op een periode in de tabelweergave, om erop in te zoomen.",
      "chartTimezone": "Tijden in {{timezone}}.",
      "backToWindow": "Hele venster",
      "tenantsTitle": "Organisaties",
      "tenantsDescription": "Organisaties met de meeste tokens in dit venster.",
      "organization": "Organisatie",
      "tokenShare": "Tokenaandeel",
      "byModel": "Tokens per model",
      "byAgent": "Tokens per agent",
      "topTools": "Meestgebruikte tools",
      "agentMessages_one": "{{count}} overdracht tussen agents",
      "agentMessages_other": "{{count}} overdrachten tussen agents",
      "noData": "Geen gebruik in dit venster.",
      "noTools": "Geen toolaanroepen in dit venster.",
      "definitions": "Hoe deze cijfers worden geteld"
    }
  }
}
